export const isWorker = () => typeof WorkerGlobalScope !== 'undefined';
export const isSSRIsolateEnv = () => '__ssrIsolateEnv' in globalThis;
export const isServer = () => (!isWorker() && typeof window === 'undefined') || isSSRIsolateEnv();
export const isBrowser = () => typeof window !== 'undefined' && typeof window.document !== 'undefined';
export const isBrowserMainThread = () => isBrowser() && !isWorker();
export const LOCAL_DEV_HOSTS = [
    'https://bo.wix.com/suricate/tunnel/',
    'https://localhost:',
    'http://localhost:',
    'https://sled.wix.dev/',
];
export function isJS(url) {
    return getExtension(url) === 'js';
}
export function isCSS(url) {
    return getExtension(url) === 'css';
}
export function getExtension(url) {
    return url.split('.').pop();
}
export function flat(arr) {
    const result = [];
    const _flat = (_arr) => {
        _arr.forEach(element => {
            if (Array.isArray(element)) {
                _flat(element);
            }
            else {
                result.push(element);
            }
        });
    };
    _flat(arr);
    return result;
}
export function yieldToMain() {
    return new Promise(resolve => setTimeout(resolve, 0));
}
//# sourceMappingURL=utils.js.map